// Note: this file is separate from ./models/utils.ts to prevent a dependency cycle

import isArray from 'lodash/isArray';

import {COMPUTED_LIST_PROPERTIES_VALUES} from 'common/query-builder/query-block/properties-menu/constants';
import {assert} from 'common/util';
import {ConstantPropertyValues} from 'common/report/util/properties';
import {PropertyType} from 'common/report/constants';

import type {PropertyFilter} from './models/property-filter';

export function isEnhancedListFilter(filter: PropertyFilter): boolean {
  return Array.isArray(filter.listItemFilters) || Boolean(filter.listQuantifier);
}

export function isListOfObjectsFilter(filter: PropertyFilter): boolean {
  return Boolean(filter.listItemFilters);
}

export function hasComputedListFilters(filter: PropertyFilter): boolean {
  return filter.listItemFilters?.some(isComputedListPropertyFilter) ?? false;
}

export function isComputedListPropertyFilter(filter: PropertyFilter) {
  assert(Array.isArray(filter.propertyName) === false, `multiple property names not supported for list of objects`);
  return typeof filter.propertyName === `string` && COMPUTED_LIST_PROPERTIES_VALUES.has(filter.propertyName);
}

/**
 * There's no support for the Not Set operator on the backend for dates so
 * we manually serialize it out to the appropriate values here.
 *
 * Defaults to returning the original filterValue if this isn't that specific
 * case.
 */
export function handleNotSetValueForDatetimeFilters(filterValue: any, defaultPropertyType: PropertyType): string[] {
  const notSetValue = filterValue === ConstantPropertyValues.NotSet;
  const notSetArrayValue = isArray(filterValue) && filterValue.includes(ConstantPropertyValues.NotSet);
  if (defaultPropertyType === PropertyType.Datetime && (notSetValue || notSetArrayValue)) {
    return [ConstantPropertyValues.NotSet, ConstantPropertyValues.EmptyString];
  }
  return filterValue;
}
